import React, { useState } from "react";
import { BsSearch } from "react-icons/bs";
import { styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { Box, Container } from "@mui/system";
import InputBase from "@mui/material/InputBase";
import Popover from "@mui/material/Popover";
import {
  Grid,
  useMediaQuery,
  useTheme,
  AppBar,
  IconButton,
  MenuItem,
  MenuList,
} from "@mui/material";
import Drawers from "./Drawer";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ChangePin from "../Dashboard/ChangePin";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  backgroundColor: "#691e781a",

  border: "0px solid #691e78",
  borderRadius: "100px",
  "&:hover": {
    // backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "345px",

  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

const PDHeader = ({ controlNav }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    navigate("/");
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      <AppBar
        sx={{
          background: "#ffffff",
          color: "#000",
          boxShadow: "none",
          width: { lg: "78%", md: "70%" },
          display: "flex",
          justifyContent: "center",
          // alignContent: "center",
          height: { lg: "100px", md: "70px", sm: "70px", xs: "70px" },
        }}
      >
        {isMatch ? (
          <>
            <Box> </Box>
            <Drawers />
          </>
        ) : (
          <>
            <Box sx={{ display: "flex", alignItems: "center", width: "95%" }}>
              <Container>
                <Grid
                  container
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Grid
                    item
                    lg={6}
                    sx={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <Search
                      sx={{
                        width: {
                          lg: "545px",
                          md: "330px",
                          sm: "auto",
                          xs: "auto",
                          pl: { xs: 6 },
                        },
                      }}
                    >
                      <SearchIconWrapper>
                        <BsSearch />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ "aria-label": "search" }}
                      />
                    </Search>
                  </Grid>

                  <Grid
                    item
                    lg={2}
                    md={3}
                    sm={3}
                    xs={3}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Badge badgeContent={2} color="error">
                      <NotificationsNoneIcon />
                    </Badge>
                    <Avatar>S</Avatar>
                    <IconButton onClick={handleClick}>
                      <MenuIcon
                        style={{ fontSize: "25px", cursor: "pointer" }}
                      />
                    </IconButton>
                  </Grid>
                </Grid>
              </Container>
            </Box>

            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuList>
                <MenuItem onClick={handleLogout} sx={{ fontSize: "15px" }}>
                  <LogoutIcon sx={{ mr: 1 }} /> Logout
                </MenuItem>
                <ChangePin />
              </MenuList>
            </Popover>
          </>
        )}
      </AppBar>
    </>
  );
};

export default PDHeader;
